import React, { type ReactElement } from 'react';
import { KbCreateCategorySubscriber } from '@atlassian/jira-kb-create-category-controller';

type NavDriverProps = {
	children: (arg1: { isOpen: boolean; onClose: () => void }) => ReactElement;
};

const NavDriver = (props: NavDriverProps) => {
	const { children } = props;
	return (
		<KbCreateCategorySubscriber>
			{({ isOpen }, { setCreateCategoryDisplay }) => {
				const onClose = () => setCreateCategoryDisplay(false);

				return children({ isOpen, onClose });
			}}
		</KbCreateCategorySubscriber>
	);
};

export default NavDriver;
